module.exports = __webpack_public_path__ + "static/media/FK.fc05b85b.png";